import React from 'react'

import { AnalyticsDataLabel } from '../../../../analyticsModule/components/AnalyticsDataLabel/AnalyticsDataLabel'
import { AnalyticsSocialPlatformLabel } from '../../../../analyticsModule/components/AnalyticsSocialPlatform/AnalyticsSocialPlatformLabel'
import type { AnalyticsSocialPlatformLabelType } from '../../../../analyticsModule/components/AnalyticsSocialPlatform/AnalyticsSocialPlatformLabel.types'
import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase'
import type { BarStatsReportCardProps } from '../../AnalyticsDashboard.types'
import { createStatsData } from '../../utils/createStatsData'

const reportId = 'sessions_by_source'

type Source = 'traffic_source' | 'social_platform'

type Options = {
  source: Source
}

type SessionsBySourceRow = {
  source: string
  session_count: number
}

const header: Record<Source, string> = {
  traffic_source: 'Sessions by traffic source',
  social_platform: 'Sessions by social platform',
}

const headerTooltipTitle: Record<Source, string> = {
  traffic_source: 'Sessions by traffic source',
  social_platform: 'Sessions by social platform',
}

const headerTooltipDescription: Record<Source, string> = {
  traffic_source: 'Breakdown of sessions grouped by where visitors came from.',
  social_platform: 'Breakdown of sessions grouped by social platform.',
}

export const useSessionsBySourceReportCard = ({ source }: Options): BarStatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({
    reportId,
    filters: { source_dimension: source },
  })

  const data = createStatsData<SessionsBySourceRow>({
    rows: analyticsCardBase.reportData?.report?.rows,
    mapFn: (row) => ({
      label:
        source === 'social_platform' ? (
          <AnalyticsSocialPlatformLabel type={row.source as AnalyticsSocialPlatformLabelType} />
        ) : (
          <AnalyticsDataLabel label={row.source} />
        ),
      value: row.session_count,
    }),
  })

  return {
    ...analyticsCardBase,
    type: 'barStats',
    header: {
      label: header[source],
      tooltip: {
        title: headerTooltipTitle[source],
        description: headerTooltipDescription[source],
      },
    },
    data,
  }
}
